"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Redirect_exports = {};
__export(Redirect_exports, {
  Redirect: () => Redirect
});
module.exports = __toCommonJS(Redirect_exports);
var import_react = require("react");
var import_hooks = require("../hooks");
var import_useFocusEffect = require("../useFocusEffect");
var redirectsInFlight = /* @__PURE__ */ new Set();
function Redirect(param) {
  var { href } = param;
  var router = (0, import_hooks.useRouter)();
  var hasRedirected = (0, import_react.useRef)(false);
  (0, import_useFocusEffect.useFocusEffect)(function() {
    if (hasRedirected.current) return;
    var key = typeof href === "string" ? href : JSON.stringify(href);
    if (redirectsInFlight.has(key)) return;
    hasRedirected.current = true;
    redirectsInFlight.add(key);
    Promise.resolve(router.replace(href)).catch(function(error) {
      hasRedirected.current = false;
      console.error(error);
    }).finally(function() {
      redirectsInFlight.delete(key);
    });
  }, [
    href
  ]);
  return null;
}
//# sourceMappingURL=Redirect.js.map
